/**
 * Cross-module X XWP-74 — the one pending « Ouvrir … dans une nouvelle fenêtre ? » question of the
 * shell (CP §11, §15.20). A screen's entry point (hooks/useFenetreSource.js `useOuvrirFenetre`) and the
 * unsaved-changes guard (a menu link to a supporting page) both post their question here; the shell's
 * single dialog (components/shell/OuvrirFenetreDialog.jsx) asks it. Nothing persisted.
 *
 * demande: { chemin, page, phrase, ici: { libelle, run } | null, erreur: string | null } | null
 */
import { create } from "zustand";

export const useFenetreSourceStore = create((set) => ({
  demande: null,
  poser: (demande) => set({ demande: { ici: null, erreur: null, ...demande } }),
  signalerErreur: (erreur) => set((s) => (s.demande ? { demande: { ...s.demande, erreur } } : s)),
  fermer: () => set({ demande: null }),
}));

/** True while the question is on screen (the legacy POS listeners leave their keys to it). */
export function demandeFenetreOuverte() {
  return useFenetreSourceStore.getState().demande != null;
}

export default useFenetreSourceStore;
